/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import type { IAssignableUser } from 'uplisting-frontend/models/inbox-message';

interface AssignedUserSelectSignature {
  Element: HTMLDivElement;
  Args: {
    options: IAssignableUser[];
    assignedUserId?: string | null;
    assignedUserName?: string | null;
    readOnly?: boolean;
    disabled?: boolean;
    onChange(user: IAssignableUser | null): void;
  };
}

export default class UiInboxAssignedUserSelectComponent extends Component<AssignedUserSelectSignature> {
  @cached
  get selected(): IAssignableUser | undefined {
    const { options, assignedUserId, assignedUserName } = this.args;

    if (!assignedUserId) {
      return undefined;
    }

    return (
      options.find((option) => option.id === assignedUserId) ?? {
        id: assignedUserId,
        name: assignedUserName ?? '',
      }
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Inbox::AssignedUserSelect': typeof UiInboxAssignedUserSelectComponent;
  }
}
